import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useWizard } from 'ui-components/components/wizard/context';

import { Button } from '../../button';

import style from '../style.module.less';

const messages = defineMessages({
  backButtonText: {
    defaultMessage: 'Back to {previousStepLabel}',
    id: 'j9flfi',
    description: 'Wizard back button',
  },
  forwardButtonText: {
    defaultMessage: 'Step Forward',
    id: 'G3rlKz',
    description: 'Wizard Forward Button',
  },
  wizardCompleteText: {
    defaultMessage: 'Complete',
    id: 'WT3vgO',
    description: 'Wizard completion button',
  },
});

export const WizardFooter = () => {
  const { previousStep, nextStep, canProgress, stepForward, stepBack, getStepLabel, onComplete } = useWizard();

  const progressButtonMessageDescriptor = nextStep ? messages.forwardButtonText : messages.wizardCompleteText;
  const onProgressButtonClick = nextStep ? stepForward : onComplete;

  return (
    <div className={style['wizard-footer']}>
      <div className={style['wizard-footer-left']}>
        {!!previousStep && (
          <Button onClick={stepBack} theme='link'>
            <FormattedMessage
              {...messages.backButtonText}
              values={{
                previousStepLabel: getStepLabel(previousStep.stepId),
              }}
            />
          </Button>
        )}
      </div>
      <div className={style['wizard-footer-right']}>
        <Button theme='tertiary'>Cancel</Button>
        <Button disabled={!canProgress} onClick={onProgressButtonClick} theme='primary'>
          <FormattedMessage {...progressButtonMessageDescriptor} />
        </Button>
      </div>
    </div>
  );
};
